import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import CardForm from './CardForm';

const stripePromiseCache = {};

const getStripeInstance = (publishableKey) => {
  if (!publishableKey) {
    throw new Error('Stripe publishable key is required.');
  }

  if (!stripePromiseCache[publishableKey]) {
    stripePromiseCache[publishableKey] = loadStripe(publishableKey);
  }

  return stripePromiseCache[publishableKey];
};

// for future appearance customizations if we decide to add more options and use appearance API
const baseAppearance = {
  theme: 'flat',
  variables: {},
  rules: {},
};

const mergeAppearance = (defaults, overrides) => {
  if (!overrides) return defaults;
  return {
    ...defaults,
    ...overrides,
    variables: {
      ...defaults.variables,
      ...(overrides.variables || {}),
    },
    rules: {
      ...defaults.rules,
      ...(overrides.rules || {}),
    },
  };
};

const ValidateCardDialog = ({
  publishableKey,
  appearance,
  email,
  onSuccess,
  onCancel,
}) => {
  const stripePromise = useMemo(() => getStripeInstance(publishableKey), [publishableKey]);
  const mergedAppearance = useMemo(() => mergeAppearance(baseAppearance, appearance), [appearance]);

  return (
    <Elements stripe={stripePromise} options={{ appearance: mergedAppearance }}>
      <CardForm
        email={email}
        onCancel={onCancel}
        onSuccess={onSuccess}
      />
    </Elements>
  );
};

ValidateCardDialog.propTypes = {
  publishableKey: PropTypes.string.isRequired,
  appearance: PropTypes.shape({
    theme: PropTypes.string,
  }),
  email: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

ValidateCardDialog.defaultProps = {
  appearance: null,
};

export default ValidateCardDialog;
